import { casebattlesStore } from '@/stores/casebattles.store';
import { modalStore } from '@/stores/modal.store';
import CaseImage from '@/components/CaseBattles/CaseImage';
import { memo, MouseEventHandler, useState } from 'react';
import { Popover } from 'react-tiny-popover';

interface Props {
    id: number;
    tinted?: boolean;
    mini?: boolean;
    count?: number;
}

const Case = memo(({ id, count, mini, tinted }: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const { getCase } = casebattlesStore((state) => state);
    const { toggleModal, setTitle, setComponent, setData } = modalStore((state) => state);

    const item = getCase(id);
    if (!item) return null;

    const openInfo: MouseEventHandler<HTMLDivElement> = (e) => {
        e.preventDefault();
        e.stopPropagation();
        setTitle(item.name);
        setComponent('Case');
        setData({ items: item.items });
        toggleModal();
    };

    const size = mini ? 'h-12 w-12' : 'h-16 w-16';
    const imgSize = mini ? 38 : 56;

    return (
        <Popover
            isOpen={isOpen}
            positions={['top']}
            padding={6}
            content={() => (
                <div className="rounded-fl bg-layer_2 border border-stroke px-3 py-2 text-[11.5px] text-text_2 backdrop-blur-md whitespace-nowrap shadow-[0_8px_18px_rgba(0,0,0,0.5)]">
                    <div className="font-semibold text-text_main">{item.name}</div>
                    <div className="text-accent_5 font-bold tabular-nums mt-0.5">
                        ${item.priceUsd.toFixed(2)}
                    </div>
                    <div className="mt-1 pt-1 border-t border-stroke text-text_4 text-[10.5px]">
                        Right click for drops
                    </div>
                </div>
            )}
        >
            <div
                className={`relative shrink-0 select-none ${size} ${tinted ? 'opacity-55' : ''}`}
                onMouseEnter={() => setIsOpen(true)}
                onMouseLeave={() => setIsOpen(false)}
                onContextMenu={openInfo}
            >
                <CaseImage width={imgSize} height={imgSize} icon={item.icon} mini={mini} />
                {!mini && count && count > 1 && (
                    <span className="absolute -top-1 -right-1 min-w-[18px] h-[18px] px-1 rounded-full grid place-items-center text-[10px] font-bold tabular-nums bg-layer_3 border border-stroke text-text_main">
                        {count}
                    </span>
                )}
                {mini && count && count > 1 && (
                    <span
                        className="absolute -top-1 -right-1 min-w-[16px] h-[16px] px-1 rounded-full grid place-items-center text-[9.5px] font-bold tabular-nums text-[#08131c]"
                        style={{ background: '#ffb13d' }}
                    >
                        {count}
                    </span>
                )}
            </div>
        </Popover>
    );
});

export default Case;
